import {Component, EventEmitter, Input, OnChanges, Output, SimpleChange} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {DocumentResult} from "../../../../../../models/document-result";
import {Registration} from "../../../../../../models/registration";
import {Requirement} from "../../../../../../models/requirement";
import {RequirementControllerService} from "../../../../../../services/requirement-controller/requirement-controller.service";
import {DocumentResultControllerService} from "../../../../../../services/result-controller/document-result-controller.service";
import {NewDeterminantHelperService} from "../../../../../../services/result-controller/new-determinant-helper.service";
import {ResultService} from "../../../../../../services/result-controller/result.service";
import {Store} from "../../../../../../services/store.service";
import {TranslatedBaseError} from "../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {
  DeterminantControllerService,
} from "../../../../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "result-list",
  templateUrl: "./result-list.component.html",
  providers: [],
  styles: [],
})
export class ResultListComponent extends TranslatedBaseError {

  public serviceId: string;
  public registration: Registration;
  public result: Requirement;
  public requirements: Requirement[] = [];
  public documentResult: any;
  public documentResultList: any[];
  public determinantMapById: { [key: string]: string } = {};
  public topLayer = "list";
  public listToggle: boolean = false;
  public addNew: boolean = false;
  public userFilter: any = {name: ""};
  public subscription: any;

  constructor(private resultService: ResultService,
              private requirementService: RequirementControllerService,
              private documentResultControllerService: DocumentResultControllerService,
              private newDeterminantHelperService: NewDeterminantHelperService,
              private determinantService: DeterminantControllerService,
              public store: Store,
              private route: ActivatedRoute,
              public toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.resultService.change.subscribe((data) => {
      this.serviceId = data.serviceId;
      this.registration = data.registration;
      this.loadServiceRequirements(data.documentResultList);
      this.getServiceDeterminantKeyName();
    });
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public loadServiceRequirements(documentResultList) {
    this.requirementService.getServiceRequirements().subscribe(
      (data) => {
        this.removeRequirementsOverlappingWithDocumentRequirementsOrDocumentResults(
          documentResultList,
          data);
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public removeRequirementsOverlappingWithDocumentRequirementsOrDocumentResults(documentRequirementsOrDocumentResults: any[], requirements: Requirement[]) {
    for (let j = documentRequirementsOrDocumentResults.length - 1; j >= 0; j--) {
      for (let i = requirements.length - 1; i >= 0; i--) {
        if (requirements[i].id === documentRequirementsOrDocumentResults[j].requirement.id) {
          requirements.splice(i, 1);
        }
      }
    }
    this.requirements = requirements;
    this.documentResultList = documentRequirementsOrDocumentResults;
  }

  public deleteDocResult(item) {
    this.documentResultControllerService.deleteRegistrationResult(item.id).subscribe(
      (data) => {
        this.resultService.updateData();
        this.responseSuccessful("Result is removed from registration");
      },
    );
  }

  public deleteRequirement(isConfirmed, item) {
    if (isConfirmed) {
      this.requirementService.deleteRequirement(item.id).subscribe(
        (data) => {
          this.resultService.updateData();
          this.responseSuccessful("Requirement is deleted!");
        },
        (error) => this.showErrorMessageWithTitle("Requirement delete error! ", error),
      );
    }
  }

  public addDocResult(item) {
    if (this.registration) {
      item.registrationId = this.registration.id;
      if (!item.requirement) {
        item.requirementId = item.id;
        this.documentResultControllerService.addRegistrationResult(this.registration.id, item).subscribe(
          (data) => {
            this.resultService.updateData();
            this.responseSuccessful("Result added!");
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
        );
      }
    }
    this.newDeterminantHelperService.cleanData();
  }

  public openEdit(result: any) {
    if (result) {
      this.documentResult = result;
      this.addNew = false;
    } else {
      this.documentResult = new DocumentResult();
      this.addNew = true;
    }
    this.topLayer = "edit";
  }

  public cancelEdit(event) {
    if (event.cancel) {
      this.topLayer = "list";
    }
  }

  public closeLayer() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = undefined;
  }

  public resultWindowSubmitted(event) {
    if (event.save) {
      this.resultService.updateData();
    }
    this.topLayer = "list";
  }

  public cancelEditCost(event) {
    if (event.cancel) {
      this.topLayer = "list";
    }
  }

  public setListView(b) {
    this.listToggle = b;
  }

}
